<template>
<div class="container">
  <div class="row pb-5">
    <sys-widget title="Total de Acreedores activos" :content="items.investors" :size="3" icon="users" />
    <sys-widget title="Monto de inversión" :content="items.amount_attachments | formatCurrency" icon="dollar-sign" :size="3" color="secondary"/>
    <sys-widget title="Total de contratos activos" :content="items.contracts" :icon="['far','file']" :size="3"/>
    <sys-widget title="Total de anexos activos" :content="items.attachments" :icon="['far','file']" :size="3" color="secondary"/>
  </div>
  <sys-table :headers="headers" :title_icon="['far','file']" :items="filtered_items_attachments" :title="title" :error_message="error_message" :contract_detail_route="detail_route_contract" />
  <div class="row">
    <div class="col-md-6">
      <sys-table :headers="headers_birthday" :items="filtered_items_birthdays" :title="title_birthday" :error_message="error_message_birthday" :detail_route="detail_route_investor" />
    </div>
    <div class="col-md-6">
      <sys-table :headers="headers_documents" :title_icon="['far','file']" :items="filtered_items_documents" :title="title_documents" :error_message="error_message" :detail_route="detail_route_investor" />
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <sys-table :headers="headers_withdraws" :title_icon="['far','clock']" :items="filtered_items_withdraws" :title="title_withdraws" :error_message="error_message_withdraws" :detail_route="detail_route_withdraw" />
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <sys-table :headers="headers_pending" :title_icon="['far','clock']" :items="filtered_items_pending" :title="title_pending" :error_message="error_message_pending" :detail_route="detail_route_pending" />
    </div>
  </div>
</div>
</template>

<script>
import dashboardService from '@/services/dashboard'
import SysTable from '@/components/shared/Table'
import SysFilter from '@/components/shared/Filter'
import SysForm from '@/components/shared/Form'
import SysWidget from '@/components/shared/Widget'

export default {
  name: 'Dashboard',

  components: { SysTable, SysFilter, SysWidget, SysForm },

  data () {
    return {
      title: 'Anexos por vencer',
      title_birthday: 'Cumpleaños de Acreedores del Mes',
      title_documents: 'Documentos faltantes',
      title_withdraws: 'Retiros por confirmar',
      title_pending: 'Tareas pendientes',
      headers: [
        { text: 'Folio contrato', value: 'contracts_folio' },
        { text: 'Anexo', value: 'attachment_id' },
        { text: 'Monto', value: 'amount', filter: 'formatCurrency' },
        { text: 'Acreedor', value: 'investor_name' },
        { text: 'Fecha de vencimiento', value: 'attachment_expire', filter: 'reverseDate' }
      ],
      headers_birthday: [
        { text: 'Acreedor', value: 'name' },
        { text: 'Cumpleaños', value: 'dob', filter: 'reverseDate' }
      ],
      headers_documents: [
        { text: 'Acreedor', value: 'investor' },
        { text: 'Documentación', value: 'document' }
      ],
      headers_withdraws: [
        { text: 'Id retiro', value: 'id' },
        { text: 'Acreedor', value: 'investor_name' },
        { text: 'Monto', value: 'amount', filter: 'formatCurrency' },
        { text: 'Fecha de retiro', value: 'date_retirement', filter: 'reverseDate' },
        { text: 'Folio contrato', value: 'folio' }
      ],
      headers_pending: [
        { text: 'Prospecto', value: 'prospect' },
        { text: 'Título', value: 'title' },
        { text: 'Contenido', value: 'content' },
        { text: 'Fecha', value: 'created_at', filter: 'formatDate' }
      ],
      detail_route_withdraw: 'withdraw',
      detail_route_investor: 'investor',
      detail_route_pending: 'prospect',
      detail_route_contract: 'contract',
      items: [],
      items_attachments: [],
      items_birthdays: [],
      items_documents: [],
      items_withdraws: [],
      items_pending: [],
      filtered_items: [],
      filtered_items_attachments: [],
      filtered_items_birthdays: [],
      filtered_items_documents: [],
      filtered_items_withdraws: [],
      filtered_items_pending: [],
      error_message: 'There\'s nothing to show',
      error_message_birthday: 'No hay cumpleaños por mostrar',
      error_message_withdraws: 'No hay retiros por confirmar',
      error_message_pending: 'No hay tareas pendientes',
      filters: [
        {
          id: 'date_from',
          name: 'Fecha Desde',
          hint: 'mm/dd/yyyy',
          icon: 'calendar-alt',
          type: 'date',
          size: 6,
          value: ''
        },
        {
          id: 'date_to',
          name: 'Fecha Hasta',
          hint: 'mm/dd/yyyy',
          icon: 'calendar-alt',
          type: 'date',
          size: 6,
          value: this.date_now()
        }
      ]
    }
  },
  beforeCreate: function () {
    // TODO: change to date filter
    let params = {}
    dashboardService.list(params).then(res => {
      this.items = this.filtered_items = res
    })
    dashboardService.attachmentList().then(res => {
      this.items_attachments = this.filtered_items_attachments = res
    })
    dashboardService.birthdayInvestorsList().then(res => {
      this.items_birthdays = this.filtered_items_birthdays = res
    })
    dashboardService.missingDocumentstList().then(res => {
      this.items_documents = this.filtered_items_documents = res
    })
    dashboardService.withdrawsDateRetirement().then(res => {
      this.items_withdraws = this.filtered_items_withdraws = res
    })
    dashboardService.pendingTasksList().then(res => {
      this.items_pending = this.filtered_items_pending = res
    })
  },
  methods: {
    search: function () {
      let params = {start_date: this.filters[0].value, end_date: this.filters[1].value}
      dashboardService.list(params).then(res => {
        this.items = this.filtered_items = res
      })
    },
    getFilters: function () {
      return this.filters.reduce((arr, filter) => {
        if (filter.value.length > 0) {
          arr.push(filter)
        }
        return arr
      }, [])
    },
    reset: function () {
      this.$emit('update:filters', this.filters.map(filter => {
        filter.value = ''
        return filter
      }))
      this.$emit('update:filtered_items', this.items)
    },
    date_now: function () {
      let now = new Date()
      now = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate()
      return now
    },
    first_day: function () {
      let now = new Date()
      now = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + '01'
      return now
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue